import { AHText, AHTextFonts, Box, TouchableBox, useCircleSize } from "arkh";
import { useDeviceOrientation } from "../../../../../common/Utils/useDeviceOrientation";

export function TeamFeatureItem(props: {
  onPress: () => void;
  title: string;
  icon: React.ReactNode;
  count?: number;
  highlighted?: boolean;
  right?: React.ReactNode;
  isGrid: boolean;
}) {
  const height = useCircleSize("smallMedium");
  const hasCount = props.count !== undefined && props.count > 0;
  const orientation = useDeviceOrientation();
  return (
    <Box
      spaceRight="medium"
      spaceTop="medium"
      style={
        props.isGrid
          ? {
              width: orientation.landscape ? "25%" : "33%",
              maxWidth: 160,
            }
          : {
              width: 140,
            }
      }
    >
      <TouchableBox
        color="surface"
        space="small"
        cornerRadius="medium"
        borderColor="border-primary"
        style={{
          borderWidth: 1,
          margin: -1,
          height: 60,
          justifyContent: "space-between",
        }}
        onPress={props.onPress}
      >
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              flex: 1,
            }}
          >
            <Box
              style={{
                height,
                width: height,
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              {props.icon}
            </Box>
            {hasCount ? (
              <AHText type="title-small">{props.count}</AHText>
            ) : null}
          </Box>
          {props.right}
        </Box>
        <AHText
          spaceTop="xsmall"
          numberOfLines={1}
          type="subtitle"
          font={
            hasCount || props.highlighted
              ? AHTextFonts.BOLD
              : AHTextFonts.REGULAR
          }
        >
          {props.title}
        </AHText>
      </TouchableBox>
    </Box>
  );
}
